export enum IncomingBankPaymentStatusEnum {
  Matched = 2,
  UnMatched = 1,
  AgLowBalance = 91,
  AgNoApproval = 92,
  AgWillRetry = 99,
}

export const FAILED_STATUSES = [
  IncomingBankPaymentStatusEnum.AgLowBalance,
  IncomingBankPaymentStatusEnum.AgNoApproval,
  IncomingBankPaymentStatusEnum.AgWillRetry,
];
export const FAILED_STATUSES_STRING = FAILED_STATUSES.join(',');
